import { StaticImageMapProps } from '.';
const token = process.env.REACT_APP_MAPBOX_TOKEN;

export function createURL(props: StaticImageMapProps): string {
  const pitch = props?.pitch ?? '0';
  const zoom = props?.zoom ?? '15.2';
  const bearing = props?.pitch ?? '0';
  const lat = props?.value?.lng ?? '0';
  const lng = props?.value?.lat ?? '0';
  const theme_ = props?.theme ?? 'light';
  const theme = theme_ === 'light' ? 'streets-v12' : 'dark-v11';
  return `https://api.mapbox.com/styles/v1/mapbox/${theme}/static/pin-s-marker+ff0000(${lat},${lng})/${lat},${lng},${zoom},${bearing},${pitch}/800x200?access_token=${token}`;
}

export const styles = (src: string) => ({
  width: '100%',
  height: '14rem',
  borderRadius: '6px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  backgroundRepeat: 'no-repeat',
  backgroundImage: `url(${src})`,
  position: 'relative',
  '& .MuiButtonBase-root': {
    position: 'absolute',
    right: '0.5rem',
    top: '0.5rem',
  },
});
